import ApiBase from './ApiBase';
import axios from 'axios';

/**
 * Postal Mail Api
 */
class PostalMailApi extends ApiBase {
  /**
   *
   * @param {*} payload
   */
  sendPostalMail = async payload => {
    const request = {
      url: `${this.API_URL}/postalmail/sendmail`,
      headers: this.getHeaders(),
      method: 'POST',
      data: JSON.stringify(payload)
    };

    const response = await axios.request(request);

    return response.data;
  };
}
export default new PostalMailApi();
